export default "__VITE_ASSET__UMhvQhrN__"